module.exports = __webpack_public_path__ + "static/media/onboarding-squiggles.2ee44334.svg";